<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<div class="flex w-full justify-center">
  <p-stepper [value]="activeStep" class="basis-[100vw] flex-1 overflow-y-auto pb-20" [linear]="true">
    <p-step-list>
      <p-step [value]="1">Datos básicos</p-step>
      <p-step [value]="2">Permisos</p-step>
      <p-step [value]="3">Completado</p-step>
    </p-step-list>
    <p-step-panels>

      <p-step-panel [value]="1">
        <ng-template #content>

          <form [formGroup]="form">
            <h1 class="mt-4 text-3xl font-semibold">Completa el formulario</h1>

            <div class="grid grid-cols-[1fr_3fr] gap-10 mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6">
              <div class="col-span-1 flex flex-col">
                <span class="text-black font-bold !text-base">Información general</span>
                <span class="mt-1 text-sm text-gray-600">Formulario de información básica acerca del usuario.</span>
              </div>

              <div class="flex max-w-lg flex-col gap-6">
                <div class="flex flex-col gap-2">
                  <label for="name">Nombres*</label>
                  <input
                    pInputText fluid
                    id="name"
                    formControlName="name"
                    placeholder="Ingrese los nombres"
                    [invalid]="isInvalid('name')"/>
                  @if (isInvalid('name')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('name') }}
                    </p-message>
                  }
                </div>

                <div class="flex flex-col gap-2">
                  <label for="lastName">Apellidos*</label>
                  <input
                    pInputText fluid
                    id="lastName"
                    formControlName="lastName"
                    placeholder="Ingrese los apellidos"
                    [invalid]="isInvalid('lastName')"/>
                  @if (isInvalid('lastName')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('lastName') }}
                    </p-message>
                  }
                </div>

                <div class="flex flex-col gap-2">
                  <label for="email">Correo electrónico*</label>
                  <input
                    pInputText fluid
                    id="email"
                    formControlName="email"
                    placeholder="Ingrese el correo electrónico"
                    [invalid]="isInvalid('email')"/>
                  @if (isInvalid('email')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('email') }}
                    </p-message>
                  }
                </div>

                <div class="flex flex-col gap-2">
                  <label for="phone">Teléfono</label>
                  <input
                    pInputText fluid
                    id="phone"
                    formControlName="phone"
                    placeholder="Ingrese el número de teléfono"
                    [invalid]="isInvalid('phone')"/>
                  @if (isInvalid('phone')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('phone') }}
                    </p-message>
                  }
                </div>
              </div>
            </div>

            <div class="grid grid-cols-[1fr_3fr] gap-10 mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6 items-center">
              <div class="col-span-1 flex flex-col">
                <span class="text-black font-bold !text-base">Usuario administrador</span>
                <span class="mt-1 text-sm text-gray-600">Los usuarios administradores son para la gestión de la plataforma.</span>
                <span class="mt-1 text-sm text-gray-600">No hacen parte de ninguna empresa y tienen acceso completo a la plataforma.</span>
              </div>

              <div class="flex max-w-lg flex-col gap-6">
                <div class="flex flex-row gap-2">
                  <p-checkbox inputId="isAdmin" [binary]="true" formControlName="isAdmin" (onChange)="handleIsAdmin($event)"/>
                  <label for="isAdmin" class="ml-2">Usuario administrador</label>
                </div>
              </div>
            </div>

            @if (!form.get('isAdmin')?.value) {
              <div class="grid grid-cols-[1fr_3fr] gap-10 mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6 items-center">
                <div class="col-span-1 flex flex-col">
                  <span class="text-black font-bold !text-base">Grupo empresarial</span>
                  <span class="mt-1 text-sm text-gray-600">Seleccione el grupo empresarial pertenecientes al perfil de usuario.</span>
                  <span class="mt-1 text-sm text-gray-600">En caso de no tener, seleccione "Ninguno".</span>
                </div>
                <div class="flex max-w-lg flex-col gap-2">
                  <label for="selectedBusinessGroup">Grupo empresarial*</label>
                  <p-select
                    fluid
                    id="selectedBusinessGroup"
                    [options]="getBusinessGroupOptions()"
                    formControlName="selectedBusinessGroup"
                    placeholder="Seleccione el grupo empresarial"
                    [filter]="true"
                    filterBy="label"
                    optionLabel="label"
                    optionValue="value"
                    (onChange)="onBusinessGroupChange($event.value)"
                    appendTo="body"
                    [invalid]="isInvalid('selectedBusinessGroup')">
                    <ng-template #selectedItem let-selectedItem>
                      @if (selectedItem) {
                        <app-business-logo
                          [logoUrl]="selectedItem.logoUrl"
                          [name]="selectedItem.label"
                          logoSize="sm">
                        </app-business-logo>
                      }
                    </ng-template>
                    <ng-template #item let-item>
                      <app-business-logo
                        [logoUrl]="item.logoUrl"
                        [name]="item.label"
                        logoSize="sm">
                      </app-business-logo>
                    </ng-template>
                  </p-select>
                  @if (isInvalid('selectedBusinessGroup')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('selectedBusinessGroup') }}
                    </p-message>
                  }
                </div>

                <div class="col-span-1 flex flex-col">
                  <span class="text-black font-bold !text-base">Empresa</span>
                  <span class="mt-1 text-sm text-gray-600">Seleccione la empresa perteneciente al perfil de usuario.</span>
                  <span class="mt-1 text-sm text-gray-600">En caso de querer asociarlo al grupo empresarial, seleccione "Todos".</span>
                </div>
                <div class="flex max-w-lg flex-col gap-2">
                  <label for="selectedBusinesses">Empresa*</label>
                  <p-multiselect
                    fluid
                    id="selectedBusinesses"
                    [options]="getBusinessOptions()"
                    formControlName="selectedBusinesses"
                    placeholder="Seleccione una empresa"
                    [disabled]="isBusinessSelectDisabled()"
                    [filter]="true"
                    filterBy="label"
                    optionLabel="label"
                    optionValue="value"
                    (onChange)="onBusinessChange($event.value)"
                    appendTo="body"
                    [selectionLimit]="isBusinessSelectMultiple() ? null : 1"
                    selectedItemsLabel="{0} empresas seleccionadas"
                    [invalid]="isInvalid('selectedBusinesses')">
                    <ng-template #selectedItem let-selectedItem>
                      @if (selectedItem) {
                        <app-business-logo
                          [logoUrl]="selectedItem.logoUrl"
                          [name]="selectedItem.label"
                          logoSize="sm">
                        </app-business-logo>
                      }
                    </ng-template>
                    <ng-template #item let-item>
                      <app-business-logo
                        [logoUrl]="item.logoUrl"
                        [name]="item.label"
                        logoSize="sm">
                      </app-business-logo>
                    </ng-template>
                  </p-multiselect>
                  @if (isInvalid('selectedBusinesses')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('selectedBusinesses') }}
                    </p-message>
                  }
                </div>

                <div class="col-span-1 flex flex-col">
                  <span class="text-black font-bold !text-base">Sedes</span>
                  <span class="mt-1 text-sm text-gray-600">Seleccione las sedes pertenecientes al perfil de usuario.</span>
                </div>
                <div class="flex max-w-lg flex-col gap-2">
                  <label for="selectedOffices">Sede*</label>
                  <p-multiselect
                    fluid
                    id="selectedOffices"
                    [options]="getOfficeOptions()"
                    [group]="true"
                    formControlName="selectedOffices"
                    placeholder="Seleccione una sede"
                    [disabled]="availableOffices.length === 0"
                    [filter]="true"
                    filterBy="label"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    selectedItemsLabel="{0} sedes seleccionadas"
                    [invalid]="isInvalid('selectedOffices')">
                    <ng-template let-group #group>
                      <app-business-logo
                        [logoUrl]="group.logoUrl"
                        [name]="group.label"
                        logoSize="sm">
                      </app-business-logo>
                    </ng-template>
                  </p-multiselect>
                  @if (isInvalid('selectedOffices')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('selectedOffices') }}
                    </p-message>
                  }
                </div>
              </div>
            }

          </form>

        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="2">
        <ng-template #content>
          <form [formGroup]="form">
            <h1 class="mt-4 text-3xl font-semibold">Permisos del usuario</h1>

            @if (form.get('isAdmin')?.value) {
              <div class="mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6">
                <p class="text-gray-700">
                  Los administradores no necesitan permisos, ya que tienen acceso a toda la plataforma.
                </p>
              </div>
            } @else {
              <h2 class="text-gray-600 mb-6">Configura los permisos de acuerdo a su rango</h2>

              <div class="grid gap-10 mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6">

                <div class="flex flex-col gap-4">
                  <!-- Botones de permisos -->
                  <div class="flex flex-wrap gap-2">
                    @for (permission of permissionsOptions; track permission.id) {
                      <p-button
                        [label]="permission.label"
                        [severity]="selectedPermission === permission.id ? 'primary' : 'secondary'"
                        [outlined]="selectedPermission !== permission.id"
                        (onClick)="onPermissionSelect(permission.id)"
                        [icon]="permission.icon"
                        iconPos="left"
                        class="flex-shrink-0">
                      </p-button>
                    }
                  </div>

                  <!-- Contenido dinámico según permiso seleccionado -->
                  <div class="mt-6 pt-6 border-t border-gray-200">
                    <h3 class="text-lg font-semibold mb-4">{{ getSelectedPermissionLabel() }}</h3>

                    <!-- Recorrer permisos dinámicamente -->
                    <div class="flex flex-col gap-4">
                      @for (permission of getSelectedPermissionsList(); track permission.code) {
                        <div class="flex flex-col gap-2">
                          <div class="flex flex-row gap-2">
                            <p-checkbox
                              [inputId]="permission.code"
                              [binary]="true"
                              [ngModel]="isPermissionSelected(permission.code)"
                              (onChange)="onPermissionToggle(permission.code, $event)"
                              [ngModelOptions]="{standalone: true}"/>
                            <label [for]="permission.code" class="font-bold cursor-pointer">{{ permission.name }}</label>
                          </div>
                          <p class="text-sm text-gray-600 ml-8">{{ permission.description }}</p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="3">
        <ng-template #content></ng-template>
      </p-step-panel>

    </p-step-panels>
  </p-stepper>

  <app-form-footer>
    <div class="flex flex-row justify-end gap-2 w-full">
      <p-button
        fluid
        label="Cancelar"
        variant="text"
        severity="primary"
        (onClick)="onClickCancel()"
        class="w-30"
      ></p-button>

      <p-button
        fluid
        label="Regresar"
        (onClick)="onClickPreviousStep()"
        severity="secondary"
        [disabled]="isFirstStep()"
        class="w-30"
      ></p-button>

      <p-button
        fluid
        label="Siguiente"
        (onClick)="onClickNextStep()"
        [disabled]="isLastStep()"
        class="w-30"
      ></p-button>
    </div>
  </app-form-footer>

  <app-dialog
    [(visible)]="visibleSuccessDialog"
    type="success"
    [title]="dialogTitle"
    [message]="dialogMessage"
    buttonText="Confirmar"
    (onButtonClick)="onDialogButtonClick()">
  </app-dialog>

  <p-toast />
</div>
